import { actionEmitter, EmitEvent } from "../config/ActionEmitter";
import { ScriptIncludeType } from "../config/Enums";
import { IApiResponse, IScriptAndStyle } from "../models/Interfaces";
import { BaseService } from "./BaseService";

export class ScriptAndStyleService extends BaseService {
  
  public getScripts = async () : Promise<Array<IScriptAndStyle>> => {
    if (this.siteKey) {
      const scripts = await this.getScriptByType(ScriptIncludeType.ClientScript);
      return scripts;
    }
    return [];
  };

  public getCss = async () : Promise<Array<IScriptAndStyle>> => {
    if (this.siteKey) {
      const css = await this.getScriptByType(ScriptIncludeType.Css);
      return css;
    }
    return [];
  };

  public getRobots = async () : Promise<Array<IScriptAndStyle>> => {
    if (this.siteKey) {
      const css = await this.getScriptByType(ScriptIncludeType.Robots);
      return css;
    }
    return [];
  };

  public getAI = async () : Promise<Array<IScriptAndStyle>> => {
    if (this.siteKey) {
      const css = await this.getScriptByType(ScriptIncludeType.AI);
      return css;
    }
    return [];
  };

  public saveScript = async (scriptcss: IScriptAndStyle) : Promise<IScriptAndStyle | null> => {
    if (this.siteKey) {
      const url: string = `/SiteAdmin/AddUpdateScriptCss`;
      const saveres = await this._ajaxService.Post<IApiResponse>(url, scriptcss, true);

      if (saveres?.StatusCode === 200 && saveres.ReturnData) {
        return saveres.ReturnData;
      } else {
        this.EmitDataError(saveres, "Failed to save script/css details");
      }
    }
    return null;
  };

  public deleteScript = async (scriptid: number) : Promise<boolean> => {
    if (this.siteKey) {
      const url: string = `/SiteAdmin/DeleteScriptCss/${this.siteKey}/${scriptid}`;
      const delres = await this._ajaxService.Get<IApiResponse>(url, true);

      if (delres?.StatusCode === 200) {
        return true;
      } else {
        this.EmitDataError(delres, "Failed to remove script/css");
      }
    }
    return false;
  };

  public newScript = (type: ScriptIncludeType) : IScriptAndStyle | null => {
    if (this.siteKey) {
      return {
        SiteId: this.siteKey,
        Code: "",
        Description: "",
        Enabled: true,
        LoadOrder: 0,
        Type: type,
        Id: 0,
        Url: "",
        Version: "0.0.1"
      };
    }
    return null;
  };

  public getScriptByType = async (type: ScriptIncludeType) : Promise<Array<IScriptAndStyle>> => {
    if (this.siteKey) {
      const url: string = `/SiteAdmin/GetScriptsCss/${this.siteKey}/${type}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res?.ReturnData) {
        return res.ReturnData
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve site scripts");
        }
      }
    }
    return [];
  };
}
